import React from "react";
import Head from "next/head";

import TrackShipmentMain from "@/components/track-shipment/track-shipment-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { useRouter } from "next/router";

const TrackShipment = () => {
  const router = useRouter();
  const { tracking_number, carrier } = router.query;

  const trackingId = Array.isArray(tracking_number)
    ? tracking_number[0]
    : tracking_number;

  const carrierName = Array.isArray(carrier) ? carrier[0] : carrier;

  return (
    <>
      <Head>
        <title>{seoData.TRACK_MY_SHIPMENT.title}</title>
        <SeoMetaData data={seoData.TRACK_MY_SHIPMENT} />
      </Head>

      <TrackShipmentMain trackingId={trackingId} carrier={carrierName} />
    </>
  );
};

export default TrackShipment;
